import { memo } from 'react';
import { Node, NodeProps } from '@xyflow/react';
import { RouteNodeType } from '@lp/features/RoutePlanner/types';
import { ORGAN_ICON } from '@/utils/helpers';
import { NodeHandleConnections } from './NodeHandleConnections';

export type HospitalNodeProps = Node<RouteNodeType['data'], 'hospitalNode'>;

export const HospitalNode = memo(({ data }: NodeProps<HospitalNodeProps>) => {
  const { organType, title } = data;
  const Icon = ORGAN_ICON[organType];

  return (
    <NodeHandleConnections>
      <div className="flex justify-center gap-1 border-1 border-warning-40 items-center bg-warning-40 pl-0 pr-0.5 rounded-sm text-white">
        <Icon width={16} height={16} />
        <span className="font-mono text-s-sb">{title}</span>
      </div>
    </NodeHandleConnections>
  );
});
